import type { PerpsOnlyStatus } from 'lib/perpsOnlyStatus';

export const CHECKOUT_FAILURE_PATH = '/checkout/failure';

export function canProcessCheckoutCallback(params: {
    hasCheckoutCallback: boolean;
    isLoggedIn: boolean;
    userId: string;
    accountPolicyStatus: PerpsOnlyStatus;
}): boolean {
    return params.hasCheckoutCallback && params.isLoggedIn && params.userId !== '';
}

export function canProcessStripeWithdrawalCallback(params: {
    stripeUserId: string | undefined;
    isLoggedIn: boolean;
    userId: string;
    accountPolicyStatus: PerpsOnlyStatus;
}): boolean {
    return !!params.stripeUserId && params.isLoggedIn && params.stripeUserId === params.userId;
}

export function buildCheckoutFailureUrl(baseUrl: string): string {
    return `${baseUrl.replace(/\/+$/, '')}${CHECKOUT_FAILURE_PATH}`;
}

export function isCheckoutFailurePathname(pathname: string): boolean {
    const normalizedPathname = pathname.toLowerCase();

    return (
        normalizedPathname === CHECKOUT_FAILURE_PATH ||
        // Keep previously issued Checkout sessions working while they still
        // point at the legacy pathname-suffix callback.
        normalizedPathname.includes('failurecheckout')
    );
}
